import { HagerBridgePermissions } from '../providers/hager-bridge-permissions'

export const DEFAULT_HAGER_BRIDGE_PERMISSIONS: HagerBridgePermissions = {
  accessGranted: false,
  wallboxPermissions: {
    assignTariff: false,
    assignToken: false,
  },
  chargingCardPermissions: {
    deleteChargingCard: false,
    editChargingCard: false,
    editChargingCardStatus: false,
    linkChargingCards: false,
  },
  tariffPermissions: {
    viewTariffs: false,
    addTariff: false,
    editTariff: false,
    deleteTariff: false,
  },
  sessionPermissions: {
    exportSessions: false,
  },
  tourGuidePermissions: {
    viewTourGuide: false,
  },
  countryInfoPermissions: {
    countryInfo: false,
  },
}
